var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.collection.link ? "a" : "div",
    {
      tag: "div",
      staticClass: "collection-tile",
      style: _vm.collectionTileStyles,
      attrs: { href: _vm.collection.link }
    },
    [
      _c("div", { staticClass: "collection-tile__content" }, [
        _c("span", { staticClass: "collection-tile__title" }, [
          _vm._v(_vm._s(_vm.collection.title))
        ]),
        _vm.collection.link && _vm.collection.buttonText
          ? _c("span", { staticClass: "collection-tile__shop-fake-button" }, [
              _vm._v(_vm._s(_vm.collection.buttonText))
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }